<template>
    <div class="w-full md:w-1/2 xl:w-1/2 p-4">
      <div class="bg-white shadow-lg rounded-lg border-t-4 border-gray-600 p-6">
        <div class="border-b border-gray-300 pb-4">
          <h1 class="text-2xl font-semibold text-gray-800">New Feed</h1>
        </div>
        <div class="mt-4 space-y-4 h-[600px] overflow-y-auto">
          <div v-for="feed in feeds" :key="feed.id" class="p-4 bg-white rounded-lg shadow-md">
            <div class="flex items-center space-x-4 border-b border-gray-300 pb-4 mb-4">
              <img v-if="schoolLogo" :src="schoolLogo" alt="School logo" class="w-12 h-12 rounded-full" />
              <i v-else class="pi pi-graduation-cap text-primary" style="font-size: 2.5rem;"></i>
              <p class="font-semibold text-lg text-gray-800">{{ feed.title }}</p>
            </div>
            <div class="border-b border-gray-300 pb-4 mb-4">
              <p class="font-semibold text-gray-700">{{ feed.content }}</p>
            </div>
            <div>
              <p class="font-semibold text-gray-700">Views: {{ feed.views }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup lang="ts">
  
import { useBranding } from '@/composables/useBranding';

const { schoolLogo } = useBranding();

const feeds = ref([
  { id: 1, title: 'First Message', content: 'Read on network topology', views: 120 },
  { id: 2, title: 'Second Message', content: 'Learn about Vue 3', views: 98 },
  { id: 3, title: 'Third Message', content: 'Understanding Tailwind CSS', views: 76 },
]);
  
const isAccordionOpen = ref(false);
  
const toggleAccordion = () => {
  isAccordionOpen.value = !isAccordionOpen.value;
};
</script>
  
  <style scoped>
  /* Add any scoped styles if needed */
  </style>
  
